
import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup,
    Label, Input, InputGroup, InputGroupAddon, Button,
    CustomInput
} from 'reactstrap';

import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'

import { alertService } from 'components/Varios/alert_service.js';
import Icon from "components/Varios/Icons.js";
import SelectItem from "components/Varios/select.js";
import Datepicker from "components/Varios/Datepicker.js";
import CardEvaluaciones from "components/Varios/CardEvaluaciones.js";
import CardEvaluacionIntegral from "components/Varios/CardEvaluacionIntegral.js";

//import FileUpload from "components/Varios/FileUpload.js";
//import FileDownload from "components/Varios/FileDownload.js";

import InputFileDownload from "components/Varios/InputFileDownload.js";
import InputFileUpload from "components/Varios/InputFileUpload.js";

import { authenticationService } from '../services/authentication.service';
import { string } from 'prop-types';
import { mensajeCamposIncompletos } from './constants';

const API_URL = configData.SERVER_URL

export class EvaluacionesData {
    idhvevaluacion: number = 0;
    idevaluacionsenres: number = 0;
    idpersona: number = 0;

    tipo: string = "";
    calificacion: number = 0;
    puntaje?: number = 0;

    fechaevaluacion: string = "";
    fechadesde: string = "";
    fechahasta: string = "";

    fechainicio?: string = "";
    fechafin?: string = "";

    idinstitucion: number = 0;
    institucion: string = "";
    calificacionmaxima: number = 0;

    descripcion: string = "";
    refarchivo: string = "";
    refarchivo1: string = "";
    refarchivo2: string = "";
    refarchivo3: string = "";
}

export class EvaluacionIntegralData {
    anio: string = "";
    resolucion: string = "";
    fecharesolucion: string = "";
    apelacionenproceso: string = "";
    inicio: string = "";
    fin: string = "";
    numeroidentificacion: string = "";
    apellidos: string = "";
    nombres: string = "";
    calificacion: string = "";
    horas: string = "";
    docenciacalificacion: string = "";
    docenciahoras: string = "";
    docenciahorasporc: string = "";
    docenciacalificacionpond: string = "";
    investigacioncalificacion: string = "";
    investigacionhoras: string = "";
    investigacionhorasporc: string = "";
    investigacioncalificacionpond: string = "";
    gestioncalificacion: string = "";
    gestionhoras: string = "";
    gestionhorasporc: string = "";
    gestioncalificacionpond: string = "";
    vinculacioncalificacion: string = "";
    vinculacionhoras: string = "";
    vinculacionhorasporc: string = "";
    vinculacioncalificacionpond: string = "";
    observacion: string = "";

}
interface EvaluacionesDataState {
    currentUser: any;
    loading: boolean;
    loadingList: boolean;
    dtoData: EvaluacionesData;
    EvaluacionesDataList: EvaluacionesData[];
    EvaluacionIntegralDataList: EvaluacionIntegralData[];
    tipoEvaluacionList: Array<any>;
    error: null,
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
}

export class Evaluaciones extends React.Component<RouteComponentProps<{}>, EvaluacionesDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, loadingList: true, dtoData: new EvaluacionesData(),
            EvaluacionesDataList: [], tipoEvaluacionList: [], error: null, tiposEvidencia: [], filesData: [], EvaluacionIntegralDataList: []
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarEvaluaciones = this.cargarEvaluaciones.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                    this.cargarEvaluaciones();
                }
            }
        );
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {
        // API PARA OBTENER TIPO
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/TIPO EVALUACION")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            tipoEvaluacionList: result.entTabla.map(d => ({
                                "value": String(d.codigo),
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los tipos.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        tipoEvaluacionList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarEvaluaciones() {
        let api = "DatosEscalafon/EvaluacionDescByIdpersona/"
        if (this.state.currentUser.roles.includes("DOCENTEGRADO,")) {
            api = "DatosEscalafon/EvaluacionDescByIdpersona/"
        }
        else if (this.state.currentUser.roles.includes("ADMINISTRATIVO,")) {
            api = "DatosEscalafon/EvaluacionSenresDescByIdpersona/"
        }

        fetch(API_URL + api + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        let filesData = this.state.filesData;
                        this.setState({
                            EvaluacionesDataList: result.entTabla,
                            loading: false,
                            loadingList: false,
                            tiposEvidencia: this.cargarEvidencias(filesData)
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener las evaluaciones.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        EvaluacionesDataList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        if (this.state.currentUser.roles.includes("DOCENTEGRADO,")) {
            fetch(API_URL + "DatosEscalafon/EvaluacionIntegralByIdpersona/" + this.state.currentUser.idpersona)
                .then(res => res.json())
                .then(
                    (result) => {
                        if (result.strEstado === "S") {
                            this.setState({
                                EvaluacionIntegralDataList: result.entTabla,
                                loading: false,
                                loadingList: false,
                            });
                        } else {
                            alertService.error("Ocurrió un error al obtener la Evaluación Integral.")
                        }
                    },
                    (error) => {
                        alert(error);
                        this.setState({
                            loading: false,
                            error,
                            EvaluacionIntegralDataList: []
                        });
                        alertService.error("Ocurrió un error: " + error)
                    }
                )
        }
    }

    handleChange(event) {
        var dto = this.state.dtoData;
        dto[event.target.name] = event.target.value;
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    handleSelectChange(value, name) {
        var dto = this.state.dtoData;
        dto[name] = value;

        if (name === "idnomenclaturatit") {
            dto["strcampodetallado"] = value;
        }

        this.setState({
            dtoData: dto,
        });
    }

    handleFileUploadChange(tipoEvidencia, uploadFile) {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
        let fileInfoState = this.state.filesData.slice();
        let fileInfoStateFiltrado = fileInfoState.filter(f => f.type !== fileInfo.type);
        fileInfoState = fileInfoStateFiltrado.concat(fileInfo);

        this.setState({
            filesData: fileInfoState,
        });

    }

    cargarEvidencias(filesData: any[]) {
        var tiposEvidencia = [
            { "value": "EV1", "label": "Evidencia de evaluación" + filesData.filter(f => f.type == "EV1").map(ff => ': ' + ff.file.name).join(', ') },
            { "value": "EV2", "label": "Evidencia 2 de evaluación" + filesData.filter(f => f.type == "EV2").map(ff => ': ' + ff.file.name).join(', ') },
            { "value": "EV3", "label": "Evidencia 3 de evaluación" + filesData.filter(f => f.type == "EV3").map(ff => ': ' + ff.file.name).join(', ') }
        ];
        return tiposEvidencia;
    }

    descargarEvidencias(infoAcademica: EvaluacionesData) {
        var evidencias = new Array();
        if (this.state.currentUser.roles.includes("DOCENTEGRADO,")) {
            if (infoAcademica.refarchivo1) {
                evidencias.push({ name: "EV1" + this.state.currentUser.identificacion + ".PDF", url: API_URL + "DatosEscalafon/RefarchivoEvaluacion/1/" + infoAcademica.idhvevaluacion });
            }
            if (infoAcademica.refarchivo2) {
                evidencias.push({ name: "EV2" + this.state.currentUser.identificacion + ".PDF", url: API_URL + "DatosEscalafon/RefarchivoEvaluacion/2/" + infoAcademica.idhvevaluacion });
            }
            if (infoAcademica.refarchivo3) {
                evidencias.push({ name: "EV3" + this.state.currentUser.identificacion + ".PDF", url: API_URL + "DatosEscalafon/RefarchivoEvaluacion/3/" + infoAcademica.idhvevaluacion });
            }

        }
        else if (this.state.currentUser.roles.includes("ADMINISTRATIVO,")) {
            if (infoAcademica.refarchivo) {
                evidencias.push({ name: "EV1" + this.state.currentUser.identificacion + ".PDF", url: API_URL + "DatosEscalafon/RefarchivoEvaluacionSenres/" + infoAcademica.idevaluacionsenres });
            }
            //if (infoAcademica.refarchivo2) {
            //    evidencias.push({ name: "EV2" + this.state.currentUser.identificacion + ".PDF", url: API_URL + "DatosEscalafon/RefarchivoEvaluacionSenres/" + infoAcademica.idevaluacionsenres });
            //}
            //if (infoAcademica.refarchivo3) {
            //    evidencias.push({ name: "EV3" + this.state.currentUser.identificacion + ".PDF", url: API_URL + "DatosEscalafon/RefarchivoEvaluacionSenres/" + infoAcademica.idevaluacionsenres });
            //}

        }

        return evidencias;
    }

    onClickLimpiar() {
        this.setState({ dtoData: new EvaluacionesData() });
    }

    onClickEdit(idhvevaluacion) {
        this.setState({
            dtoData: new EvaluacionesData()
        });

        let api = "DatosEscalafon/EvaluacionById/"
        if (this.state.currentUser.roles.includes("DOCENTEGRADO,")) {
            api = "DatosEscalafon/EvaluacionById/"
        }
        else if (this.state.currentUser.roles.includes("ADMINISTRATIVO,")) {
            api = "DatosEscalafon/EvaluacionSenresById/"
        }

        fetch(API_URL + api + idhvevaluacion)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        let filesData = this.state.filesData;
                        this.setState({
                            dtoData: result.entTabla[0],
                            tiposEvidencia: this.cargarEvidencias(filesData),
                            loading: false
                        });

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);

                    } else {
                        alertService.error(result["strMensaje"])
                    }

                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        dtoData: new EvaluacionesData()
                    });
                    alertService.error("Ocurrió un error")
                }
            )
    }

    onClickDelete(idhvevaluacion) {
        fetch(API_URL + "FormularioController/DeleteDatosEvaluacion/" + idhvevaluacion, {

            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },

        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"])
                    }
                    else {
                        alertService.success("La evaluación se eliminó correctamente.")
                        this.cargarEvaluaciones();
                    }
                })
    }

    private postFiles(postFilesUrl, filesData, identidad) {
        if (filesData.length > 0) {
            var formFilesData = new FormData();

            filesData.map((fileData) => {
                formFilesData.append("files", fileData.file, fileData.file.name);
            });

            formFilesData.append('identidad', identidad);

            fetch(API_URL + postFilesUrl, {
                method: 'POST',
                body: formFilesData
            })
                .then(response => response.json())
                .then(
                    (responseJson) => {
                        if (responseJson["strEstado"] === "N") {
                            alertService.error("Ocurrió un error al guardar las evidencias.")
                        }
                        else if (responseJson["strEstado"] === "S") {

                            alertService.success("Las evidencias se cargaron exitosamente");
                        }
                    },
                    (error) => { alertService.error("Ocurrió un error al cargar las evidencias.") }
                );
        }
    }

    private handleSave(event) {
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = this.state.dtoData;
        var filesData = this.state.filesData;
        let formIsValid = true;
        let errors = "";

        if (dto['fechadesde'] > dto['fechahasta']) {
            alertService.error("Error: La fecha de inicio debe ser menor a la fecha de fin.");
            return;
        }

        forma.forEach((value, clave) => {
            if (!value && clave !== "evidencias") {
                formIsValid = false;
                errors = "Por favor seleccione todos los campos. "
            }

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;

            if (clave === 'fechaevaluacion' || clave === 'fechadesde' || clave === 'fechahasta') {
                value = String(value)
                var info = value.split('/').reverse().join('-');
                var date = new Date(String(info))
                dto[clave] = date.toJSON();
            }

        });

        if (formIsValid) {
            delete dto['fechainicio'];
            delete dto['fechafin'];
            delete dto['puntaje'];
        }

        dto['calificacion'] = Number(dto['calificacion']);
        dto['calificacionmaxima'] = Number(dto['calificacionmaxima']);

        if (dto['calificacion'] > dto['calificacionmaxima']) {
            alertService.error("Error: El puntaje deber ser menor o igual al puntaje máximo.");
            return;
        }

        dto.idpersona = this.state.currentUser.idpersona;

        const data = JSON.stringify({
            "entidad": dto,
        });

        if (formIsValid) {
            if (dto.idhvevaluacion === 0) {
                fetch(API_URL + "FormularioController/PostDatosEvaluacion", {

                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(mensajeCamposIncompletos())
                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("La evaluación se ha actualizado correctamente.");
                                authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())

                                this.postFiles("FormularioController/PostFilesDatosEscalafon/Evaluaciones", filesData, responseJson.entidad.idhvevaluacion);

                                this.cargarEvaluaciones();
                                this.onClickLimpiar();
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }
                        },
                        (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        })
            }
            else {
                fetch(API_URL + "FormularioController/PutDatosEvaluacion", {

                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(responseJson["strMensaje"])
                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("La evaluación se ha registrado correctamente.");
                                authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())


                                this.postFiles("FormularioController/PostFilesDatosEscalafon/Evaluaciones", filesData, responseJson.entidad.idhvevaluacion);

                                this.onClickLimpiar();
                                this.cargarEvaluaciones();
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }
                        }
                        , (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        }
                    )
            }
        }
        else {
            alertService.error("Ocurrió un error: " + errors);
        }

    }

    public render() {

        let contents = this.state.loading

            ? <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : this.renderForm(this.state.EvaluacionesDataList, this.state.tiposEvidencia, this.state.tipoEvaluacionList, this.state.EvaluacionIntegralDataList);
        return <div className="content">

            {contents}

        </div>;

    }

    // Returns the HTML Form to the render() method.  

    private renderForm(EvaluacionesDataList: Array<any>, tiposEvidencia: Array<any>, tipoEvaluacionList: Array<any>, EvaluacionIntegralDataList: Array<any>) {

        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">Evaluaciones</h5>
                            </CardHeader>
                            <CardBody className="main-content">

                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>
                                        </div>
                                        :
                                        <Tabs defaultActiveKey={this.state.currentUser.roles.includes("DOCENTEGRADO,") ? "evaluacionesIntegral" : "evaluaciones"}>
                                            {(
                                                this.state.currentUser.roles.includes("DOCENTEGRADO,") ?
                                                    <Tab eventKey="evaluacionesIntegral" title="EVALUACIÓN INTEGRAL DE ESPOL">
                                                        <Row id="lista">
                                                            {EvaluacionIntegralDataList.map((dto, index) =>
                                                                <CardEvaluacionIntegral
                                                                    key={index}
                                                                    objeto={dto}
                                                                    roles={this.state.currentUser.roles}
                                                                    number={(index + 1) + " / " + EvaluacionIntegralDataList.length}
                                                                />
                                                            )}
                                                        </Row>
                                                    </Tab>
                                                    :
                                                    null
                                            )}
                                            <Tab eventKey="evaluaciones" title="OTRAS EVALUACIONES">
                                                {(
                                                    this.state.currentUser.roles.includes("DOCENTEGRADO,") ?
                                                        <div>
                                                            <form onSubmit={this.handleSave}>


                                                                <Row form>
                                                                    {(
                                                                        this.state.currentUser.roles.includes("DOCENTEGRADO,") ?
                                                                            <Col md={4}>
                                                                                <FormGroup>
                                                                                    <Label for="tipo">Tipo evaluación*</Label>
                                                                                    <SelectItem
                                                                                        options={tipoEvaluacionList}
                                                                                        value={this.state.dtoData.tipo ? this.state.dtoData.tipo.trim() : ""}
                                                                                        onChange={this.handleSelectChange}
                                                                                        placeholder=""
                                                                                        name="tipo"
                                                                                        id="tipo"
                                                                                        icon="fa-caret-right"
                                                                                    />
                                                                                </FormGroup>
                                                                            </Col>
                                                                            :
                                                                            null
                                                                    )}
                                                                    <Col md={2}>
                                                                        <FormGroup>
                                                                            <Label for="calificacion">Calificación*</Label>
                                                                            <Input type="number" step=".01" name="calificacion" id="calificacion" value={this.state.currentUser.roles.includes("DOCENTEGRADO,") ? this.state.dtoData.calificacion : this.state.dtoData.puntaje} onChange={this.handleChange} required readOnly={this.state.currentUser.roles.includes("ADMINISTRATIVO,") ? true : false} />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={2}>
                                                                        <FormGroup>
                                                                            <Label for="calificacion">Calificación máxima*</Label>
                                                                            <Input type="number" step=".01" name="calificacionmaxima" id="calificacionmaxima" value={this.state.dtoData.calificacionmaxima} onChange={this.handleChange} required readOnly={this.state.currentUser.roles.includes("ADMINISTRATIVO,") ? true : false} />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={4}>
                                                                        <FormGroup>
                                                                            <Label for="institucion">Institución*</Label>
                                                                            <Input maxLength="250" name="institucion" id="institucion" value={this.state.dtoData.institucion} onChange={this.handleChange} required />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={2}>
                                                                        <Label for="fechaevaluacion">Fecha evaluación*</Label>
                                                                        <Datepicker
                                                                            value={this.state.dtoData.fechaevaluacion}
                                                                            name="fechaevaluacion"
                                                                            id="fechaevaluacion"
                                                                            onChange={this.handleSelectChange}
                                                                            disabled={this.state.currentUser.roles.includes("ADMINISTRATIVO,") ? true : false}
                                                                        />
                                                                    </Col>
                                                                    <Col md={2}>
                                                                        <Label for="fechadesde">Período desde*</Label>
                                                                        <Datepicker
                                                                            value={this.state.currentUser.roles.includes("DOCENTEGRADO,") ? this.state.dtoData.fechadesde : this.state.dtoData.fechainicio}
                                                                            name="fechadesde"
                                                                            id="fechadesde"
                                                                            onChange={this.handleSelectChange}
                                                                            disabled={this.state.currentUser.roles.includes("ADMINISTRATIVO,") ? true : false}
                                                                        />
                                                                    </Col>
                                                                    <Col md={2}>
                                                                        <Label for="fechahasta">Período hasta*</Label>
                                                                        <Datepicker
                                                                            value={this.state.currentUser.roles.includes("DOCENTEGRADO,") ? this.state.dtoData.fechahasta : this.state.dtoData.fechafin}
                                                                            name="fechahasta"
                                                                            id="fechahasta"
                                                                            onChange={this.handleSelectChange}
                                                                            disabled={this.state.currentUser.roles.includes("ADMINISTRATIVO,") ? true : false}
                                                                        />
                                                                    </Col>
                                                                    {(
                                                                        this.state.currentUser.roles.includes("DOCENTEGRADO,") ?
                                                                            <Col md={6}>
                                                                                <FormGroup>
                                                                                    <Label for="descripcion">Descripción*</Label>
                                                                                    <Input maxLength="500" type="text" name="descripcion" id="descripcion" value={this.state.dtoData.descripcion} onChange={this.handleChange} required />
                                                                                </FormGroup>
                                                                            </Col>
                                                                            :
                                                                            null
                                                                    )}

                                                                    <Col md={3}>
                                                                        <Label for="fechagraduacion">Evidencia</Label>
                                                                        <FormGroup row>
                                                                            <Col md={(this.state.dtoData.refarchivo1 ? 10 : 12)}>
                                                                                <InputFileUpload
                                                                                    icon="upload"
                                                                                    onChange={this.handleFileUploadChange}
                                                                                    name="EV1"
                                                                                    placeholder={this.state.dtoData.refarchivo1 ? "Actualizar Evidencia de evaluación 1" : "Subir Evidencia de evaluación 1"} />
                                                                            </Col>
                                                                            {(
                                                                                this.state.currentUser.roles.includes("DOCENTEGRADO,") ?
                                                                                    <InputFileDownload tipo="evidencia 1"
                                                                                        id="downloadRef1"
                                                                                        refarchivo={this.state.dtoData.refarchivo1}
                                                                                        name={"EV1" + this.state.currentUser.identificacion + ".PDF"}
                                                                                        url={API_URL + "DatosEscalafon/RefarchivoEvaluacion/1/" + this.state.dtoData.idhvevaluacion}
                                                                                    />
                                                                                    :
                                                                                    <InputFileDownload tipo="evidencia 1"
                                                                                        id="downloadRef1"
                                                                                        refarchivo={this.state.dtoData.refarchivo1}
                                                                                        name={"EV1" + this.state.currentUser.identificacion + ".PDF"}
                                                                                        url={API_URL + "DatosEscalafon/RefarchivoEvaluacionSenres/" + this.state.dtoData.idevaluacionsenres}
                                                                                    />
                                                                            )}
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={3}>
                                                                        <Label for="fechagraduacion">Evidencia</Label>
                                                                        <FormGroup row>
                                                                            <Col md={(this.state.dtoData.refarchivo2 ? 10 : 12)}>
                                                                                <InputFileUpload
                                                                                    icon="upload"
                                                                                    onChange={this.handleFileUploadChange}
                                                                                    name="EV2"
                                                                                    placeholder={this.state.dtoData.refarchivo2 ? "Actualizar Evidencia de evaluación 2" : "Subir Evidencia de evaluación 2"} />
                                                                            </Col>
                                                                            {(
                                                                                this.state.currentUser.roles.includes("DOCENTEGRADO,") ?
                                                                                    <InputFileDownload tipo="evidencia 2"
                                                                                        id="downloadRef2"
                                                                                        refarchivo={this.state.dtoData.refarchivo2}
                                                                                        name={"EV2" + this.state.currentUser.identificacion + ".PDF"}
                                                                                        url={API_URL + "DatosEscalafon/RefarchivoEvaluacion/2/" + this.state.dtoData.idhvevaluacion}
                                                                                    />
                                                                                    :
                                                                                    <InputFileDownload tipo="evidencia 2"
                                                                                        id="downloadRef2"
                                                                                        refarchivo={this.state.dtoData.refarchivo2}
                                                                                        name={"EV2" + this.state.currentUser.identificacion + ".PDF"}
                                                                                        url={API_URL + "DatosEscalafon/RefarchivoEvaluacionSenres/" + this.state.dtoData.idevaluacionsenres}
                                                                                    />
                                                                            )}
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={3}>
                                                                        <Label for="fechagraduacion">Evidencia</Label>
                                                                        <FormGroup row>
                                                                            <Col md={(this.state.dtoData.refarchivo3 ? 10 : 12)}>
                                                                                <InputFileUpload
                                                                                    icon="upload"
                                                                                    onChange={this.handleFileUploadChange}
                                                                                    name="EV3"
                                                                                    placeholder={this.state.dtoData.refarchivo3 ? "Actualizar Evidencia de evaluación 3" : "Subir Evidencia de evaluación 3"} />
                                                                            </Col>
                                                                            {(
                                                                                this.state.currentUser.roles.includes("DOCENTEGRADO,") ?
                                                                                    <InputFileDownload tipo="evidencia 3"
                                                                                        id="downloadRef3"
                                                                                        refarchivo={this.state.dtoData.refarchivo3}
                                                                                        name={"EV3" + this.state.currentUser.identificacion + ".PDF"}
                                                                                        url={API_URL + "DatosEscalafon/RefarchivoEvaluacion/3/" + this.state.dtoData.idhvevaluacion}
                                                                                    />
                                                                                    :
                                                                                    <InputFileDownload tipo="evidencia 3"
                                                                                        id="downloadRef3"
                                                                                        refarchivo={this.state.dtoData.refarchivo3}
                                                                                        name={"EV3" + this.state.currentUser.identificacion + ".PDF"}
                                                                                        url={API_URL + "DatosEscalafon/RefarchivoEvaluacionSenres/" + this.state.dtoData.idevaluacionsenres}
                                                                                    />
                                                                            )}
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>

                                                                {(
                                                                    this.state.currentUser.roles.includes("DOCENTEGRADO,") ?
                                                                        <Row form>
                                                                            <Col md={12}>
                                                                                <FormGroup>
                                                                                    <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickLimpiar()}>Limpiar</Button>
                                                                                    <Button color="secondary" type="submit" className="btn btn-default" style={{ float: "right" }}>Guardar</Button>
                                                                                </FormGroup>
                                                                            </Col>
                                                                        </Row>
                                                                        :
                                                                        null
                                                                )}

                                                            </form >
                                                            <br />
                                                        </div>
                                                        :
                                                        null
                                                )}

                                                <Row id="lista">
                                                    {EvaluacionesDataList.map((dto, index) =>
                                                        <CardEvaluaciones
                                                            key={this.state.currentUser.roles.includes("DOCENTEGRADO,") ? dto.idhvevaluacion : dto.idevaluacionsenres}
                                                            objeto={dto}
                                                            roles={this.state.currentUser.roles}
                                                            evidencias={this.descargarEvidencias(dto)}
                                                            number={(index + 1) + " / " + EvaluacionesDataList.length}
                                                            eventEdit={() => this.state.currentUser.roles.includes("DOCENTEGRADO,") ? this.onClickEdit(dto.idhvevaluacion) : this.onClickEdit(dto.idevaluacionsenres)}
                                                            eventDelete={() => this.onClickDelete(dto.idhvevaluacion)}
                                                        />
                                                    )}
                                                </Row>
                                            </Tab>

                                        </Tabs>

                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </>
        );
    }
}

export default Evaluaciones;